import useViewContext from '/druid/internal/useViewContext';

export default function useIndexFraction() {
  const { indexFraction } = useViewContext();

  return [indexFraction];
}
